import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Container } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import 'app/modules/Shared/Terms/Terms.scss';
import {
  faFacebook,
  faTwitter,
  faGooglePlusG,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Terms extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const { t } = this.props;
    return (
      <>
        <h1 className="text-center">{t('pages.terms.title')}</h1>
        <hr className="separator-solid" />
        <Container className="terms">
          <Row>
            <Col lg={{ span: 12 }}>
              <div>
                <p className="pt-5">{t('pages.terms.description')}</p>
                <p className="pb-5">{t('pages.terms.description1')}</p>
              </div>
              <div>
                <p>{t('pages.terms.sharePage')}</p>
              </div>
              <div className="ft-24">
                <FontAwesomeIcon icon={faFacebook} />
                <span className="pl-2">{t('pages.terms.facebook')}</span>
              </div>
              <div className="ft-24">
                <FontAwesomeIcon icon={faTwitter} role="img" />
                <span className="pl-2">{t('pages.terms.twitter')}</span>
              </div>
              <div className="ft-24 pb-3">
                <FontAwesomeIcon icon={faGooglePlusG} role="img" />
                <span className="pl-2">{t('pages.terms.googlePlus')}</span>
              </div>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}
Terms.propTypes = {
  t: PropTypes.func.isRequired,
};
export default withTranslation()(Terms);
